import { render, staticRenderFns } from "./SurveyTendencyComparisonTable.vue?vue&type=template&id=0d38f4d8"
import script from "./SurveyTendencyComparisonTable.vue?vue&type=script&lang=js"
export * from "./SurveyTendencyComparisonTable.vue?vue&type=script&lang=js"
import style0 from "./SurveyTendencyComparisonTable.vue?vue&type=style&index=0&id=0d38f4d8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports